import { render, staticRenderFns } from "./lowPriceSearch.vue?vue&type=template&id=6a2ba9c8"
import script from "./lowPriceSearch.vue?vue&type=script&lang=js"
export * from "./lowPriceSearch.vue?vue&type=script&lang=js"
import style0 from "./lowPriceSearch.vue?vue&type=style&index=0&id=6a2ba9c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports